/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormalizedProjectRevisionCourierChannel { 
    /**
     * The Channel\'s public ID
     */
    channel_id: string;
    /**
     * The creation date
     */
    readonly created_at?: string;
    /**
     * API key location  Can either be \"header\" or \"query\"
     */
    request_config_auth_config_api_key_in?: string;
    /**
     * API key name  Only used if the auth type is api_key
     */
    request_config_auth_config_api_key_name?: string;
    /**
     * API key value  Only used if the auth type is api_key
     */
    request_config_auth_config_api_key_value?: string;
    /**
     * Basic Auth Password  Only used if the auth type is basic_auth
     */
    request_config_auth_config_basic_auth_password?: string;
    /**
     * Basic Auth Username  Only used if the auth type is basic_auth
     */
    request_config_auth_config_basic_auth_user?: string;
    /**
     * HTTP Auth Method to use for the HTTP call  Can either be basic_auth or api_key basic_auth CourierChannelAuthTypeBasicAuth api_key CourierChannelAuthTypeApiKey
     */
    request_config_auth_type?: NormalizedProjectRevisionCourierChannel.RequestConfigAuthTypeEnum;
    /**
     * URI pointing to the JsonNet template used for HTTP body payload generation.
     */
    request_config_body: string;
    /**
     * NullJSONRawMessage represents a json.RawMessage that works well with JSON, SQL, and Swagger and is NULLable-
     */
    request_config_headers?: object | null;
    /**
     * The HTTP method to use (GET, POST, etc) for the HTTP call
     */
    request_config_method: string;
    request_config_url?: string;
    /**
     * Last upate time
     */
    readonly updated_at?: string;
}
export namespace NormalizedProjectRevisionCourierChannel {
    export type RequestConfigAuthTypeEnum = 'basic_auth' | 'api_key';
    export const RequestConfigAuthTypeEnum = {
        BasicAuth: 'basic_auth' as RequestConfigAuthTypeEnum,
        ApiKey: 'api_key' as RequestConfigAuthTypeEnum
    };
}


